const hexToRgba = (hex: string, alpha: number): string => {
  const rgbColors: RegExpMatchArray | null = hex.match(/\w\w/g);
  const [r, g, b] = rgbColors?.map((x) => parseInt(x, 16)) as number[];
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export default hexToRgba;
